import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.alsphere');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-alsphere',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.alsphere/view.scss */
:host {
  display: block;
  min-height: 0;
  height: 100%;
  overflow: auto;
  color: #1e293b;
  background: #f7f9fc;
}

:host([hidden]) {
  display: none !important;
}

* {
  box-sizing: border-box;
}

.alsphere-panel {
  width: min(100%, 900px);
  margin: 0 auto;
  padding: 20px;
  font-size: 13px;
  line-height: 1.6;
}

.alsphere-heading {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 16px;
}

.alsphere-mark {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: 12px;
  color: #fff;
  background: #1268c4;
  font-weight: 700;
}

h3, h4, p {
  margin: 0;
}

h3 {
  font-size: 17px;
}

h4 {
  font-size: 14px;
}

.alsphere-heading p, .alsphere-muted {
  color: #64748b;
}

.alsphere-tabs {
  display: flex;
  gap: 6px;
  margin-bottom: 16px;
  border-bottom: 1px solid #dbe4ef;
  padding-bottom: 10px;
}

button {
  border: 1px solid #cbd5e1;
  background: #fff;
  border-radius: 8px;
  min-height: 36px;
  padding: 7px 12px;
  color: #334155;
  font: inherit;
  cursor: pointer;
}

button:hover:not(:disabled) {
  border-color: #1268c4;
  color: #1268c4;
}

button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

button:focus-visible, input:focus-visible, select:focus-visible, pre:focus-visible {
  outline: 2px solid #1268c4;
  outline-offset: 2px;
}

.alsphere-tabs .is-active, .alsphere-primary {
  background: #1268c4;
  color: white;
  border-color: #1268c4;
}

.alsphere-tabs .is-active:hover, .alsphere-primary:hover:not(:disabled) {
  color: white;
  background: #0d56a7;
}

.alsphere-workspace {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.alsphere-workspace > button {
  align-self: flex-start;
}

.alsphere-guide, .alsphere-notice {
  color: #15539a;
  background: #eaf3ff;
  padding: 10px 12px;
  border-radius: 9px;
}

.alsphere-error {
  color: #a52121;
  background: #fff0f0;
  border: 1px solid #f4caca;
  padding: 10px 12px;
  border-radius: 9px;
}

.alsphere-error, .alsphere-notice {
  margin-bottom: 12px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

label {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 5px;
}

label > span {
  font-weight: 600;
}

label small {
  color: #64748b;
  font-weight: 400;
}

label > span > small {
  margin-left: 6px;
}

input, select {
  width: 100%;
  min-width: 0;
  min-height: 37px;
  padding: 7px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  color: #1e293b;
  font: inherit;
}

input[type=file] {
  font-size: 12px;
}

.alsphere-row {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.alsphere-row label {
  flex: 1;
  min-width: 150px;
}

.alsphere-parameters, .alsphere-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(145px, 1fr));
  gap: 12px;
}

.alsphere-options > p {
  grid-column: 1/-1;
  color: #64748b;
}

.alsphere-detail {
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid #dbe4ef;
  border-radius: 12px;
  padding: 16px;
  background: #fff;
}

.alsphere-detail > button {
  align-self: flex-start;
}

.alsphere-model-summary {
  display: flex;
  flex-direction: column;
  overflow-wrap: anywhere;
}

.alsphere-model-summary span {
  color: #64748b;
}

.alsphere-result {
  min-width: 0;
}

pre {
  max-height: 360px;
  overflow: auto;
  white-space: pre;
  font: 12px/1.7 ui-monospace, monospace;
  padding: 12px;
  margin: 8px 0 0;
  color: #dbeafe;
  background: #10233c;
  border-radius: 10px;
}

.alsphere-status {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 12px;
  background: #fff;
  border: 1px solid #dbe4ef;
  border-radius: 9px;
  overflow-wrap: anywhere;
}

.alsphere-status button {
  align-self: flex-start;
}

progress {
  width: 100%;
  height: 10px;
  accent-color: #1268c4;
}

@media (max-width: 480px) {
  .alsphere-panel {
    padding: 12px;
  }
  .alsphere-tabs button {
    flex: 1;
    padding: 7px;
  }
  .alsphere-detail {
    padding: 12px;
  }
}`],
})
export class ComponentAlsphereComponent implements OnInit, OnDestroy {
    public loading: boolean = false;
    public busy: string = '';
    public error: string = '';
    public notice: string = '';
    public modelProcesses: any[] = [];
    public models: any[] = [];
    public processFilter: string = '';
    public selectedId: string = '';
    public detail: any = null;
    public parameters: any[] = [];
    public mainParameter: string = '';
    public sampleNum: number = 51;
    public gridResolution: number = 51;
    public depthNum: number = 51;
    public lateralNum: number = 51;
    public yMin: number | null = null;
    public yMax: number | null = null;
    public zMin: number | null = null;
    public zMax: number | null = null;
    public result: any = null;
    public resultText: string = '';
    private csrfToken: string = '';
    private requests = new Set<AbortController>();
    private destroyed: boolean = false;
    private selectionSequence: number = 0;
    private catalogSequence: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadCatalog();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.requests.forEach(controller => controller.abort());
        this.requests.clear();
    }

    private async refresh() {
        if (!this.destroyed) await this.service.render();
    }

    private async call(action: string, params: any = {}) {
        const body = new FormData();
        Object.keys(params).forEach(key => body.append(key, typeof params[key] === 'string' ? params[key] : JSON.stringify(params[key])));
        const headers: Record<string, string> = {};
        if (action === 'predict') headers['X-CSRF-Token'] = this.csrfToken;
        const controller = new AbortController();
        this.requests.add(controller);
        const timer = setTimeout(() => controller.abort(), action === 'predict' ? 180000 : 45000);
        try {
            const response = await fetch('/wiz/api/page.agent/alsphere_' + action, {
                method: 'POST', body, headers, credentials: 'same-origin', signal: controller.signal
            });
            let payload: any;
            try { payload = await response.json(); }
            catch (_error) { throw new Error('알세미 응답을 확인할 수 없습니다. 로그인 상태를 확인하고 다시 시도해 주세요.'); }
            const code = Number(payload?.code || response.status);
            if (!response.ok || code < 200 || code >= 300) {
                const message = payload?.data?.error?.message || payload?.data?.message || payload?.message || payload?.data?.error || payload?.error;
                throw new Error(typeof message === 'string' ? message : '알세미 요청에 실패했습니다. 입력값과 로그인 상태를 확인해 주세요.');
            }
            return payload.data;
        } catch (error: any) {
            if (error?.name === 'AbortError') throw new Error('응답 대기 시간이 지났습니다. 목록 또는 상태를 새로 조회해 주세요.');
            throw error;
        } finally {
            clearTimeout(timer);
            this.requests.delete(controller);
        }
    }

    public async loadCatalog() {
        const sequence = ++this.catalogSequence;
        this.loading = true;
        this.error = '';
        await this.refresh();
        try {
            const data = await this.call('catalog', { step_process: this.processFilter });
            if (sequence !== this.catalogSequence || this.destroyed) return;
            this.csrfToken = String(data?.csrfToken || '');
            this.modelProcesses = Array.isArray(data?.model_processes) ? data.model_processes : [];
            this.models = this.processFilter && Array.isArray(data?.models)
                ? data.models.filter((model: any) => model.process_id === this.processFilter) : [];
            if (this.selectedId && !this.models.some(model => this.modelId(model) === this.selectedId)) this.clearSelection();
        } catch (error: any) {
            if (sequence === this.catalogSequence) this.error = error.message;
        } finally {
            if (sequence === this.catalogSequence) this.loading = false;
            await this.refresh();
        }
    }

    public async changeProcess() {
        this.clearSelection();
        this.models = [];
        this.notice = '';
        await this.loadCatalog();
    }

    public modelId(model: any) { return String(model?.model_id || model?.id || ''); }

    public modelLabel(model: any) {
        return [model.project_name, model.name || model.model_name || this.modelId(model), model.step_process, model.model_type, this.statusLabel(model), this.status(model) === 'TRAINING' ? this.progress(model) + '%' : ''].filter(Boolean).join(' · ');
    }

    public status(model: any) { return String(model?.status || '').toUpperCase(); }

    public statusLabel(model: any) {
        const labels: any = { READY: '준비 완료', TRAINING: '학습 중', PENDING: '대기 중', PROCESSING: '전처리 중', FAILED: '실패', ERROR: '오류' };
        return labels[this.status(model)] || String(model?.status || '상태 확인 중');
    }

    public progress(model: any) {
        const value = Number(model?.progress ?? 0);
        return Number.isFinite(value) ? Math.round(Math.min(100, Math.max(0, value <= 1 ? value * 100 : value))) : 0;
    }

    public usable(model: any) { return this.status(model) === 'READY'; }

    public kind() {
        const type = String(this.detail?.model_type || '').replace(/[ _-]/g, '').toLowerCase();
        if (type === 'p2innbinaryclassifier2d' || type === 'binaryclassifier2d') return 'etch';
        if (type === 'hybridrandomforest') return 'photo';
        if (type === 'p2inn') return 'doping';
        if (type === 'randomforest') return 'iv';
        return 'curve';
    }

    private clearSelection() {
        this.selectionSequence++;
        this.selectedId = '';
        this.detail = null;
        this.parameters = [];
        this.result = null;
        this.resultText = '';
    }

    public async selectModel() {
        const sequence = ++this.selectionSequence;
        const selectedId = this.selectedId;
        this.detail = null;
        this.result = null;
        this.resultText = '';
        this.parameters = [];
        this.error = '';
        if (!this.processFilter || !this.models.some(model => this.modelId(model) === selectedId)) { this.clearSelection(); await this.refresh(); return; }
        if (!selectedId) { await this.refresh(); return; }
        this.busy = 'detail';
        await this.refresh();
        try {
            const detail = await this.call('model', { model_id: selectedId });
            if (sequence !== this.selectionSequence || this.destroyed) return;
            this.detail = detail;
            this.parameters = (Array.isArray(detail?.input_parameters) ? detail.input_parameters : []).map((p: any) => ({
                ...p, value: p.defaultValue ?? p.minValue ?? 0
            }));
            const main = this.parameters.find(p => p.canBeMainParam);
            this.mainParameter = main?.name || '';
            const y = this.parameters.find(p => /lateral|profile_y|^y$/i.test(p.name));
            const z = this.parameters.find(p => /depth|profile_z|^z$/i.test(p.name));
            this.yMin = y?.minValue ?? null; this.yMax = y?.maxValue ?? null;
            this.zMin = z?.minValue ?? null; this.zMax = z?.maxValue ?? null;
        } catch (error: any) {
            if (sequence === this.selectionSequence) this.error = error.message;
        } finally {
            if (sequence === this.selectionSequence) this.busy = '';
            await this.refresh();
        }
    }

    public isCoordinate(parameter: any) {
        return /depth|lateral|position|profile|coordinate|coord|^y$|^z$/i.test(String(parameter.name || ''));
    }

    public inputParameters() {
        if (this.kind() === 'etch' || this.kind() === 'doping') return this.parameters.filter(p => !this.isCoordinate(p));
        return this.parameters;
    }

    public mainParameters() { return this.parameters.filter(p => p.canBeMainParam); }

    public parameterRange(parameter: any) {
        return (parameter.minValue ?? '—') + ' ~ ' + (parameter.maxValue ?? '—');
    }

    public async inputChanged() { this.error = ''; await this.refresh(); }

    private numberValue(value: any, label: string) {
        if (value === '' || value === null || value === undefined || !Number.isFinite(Number(value))) throw new Error(label + '에 숫자를 입력해 주세요.');
        return Number(value);
    }

    private count(value: any, label: string) {
        const number = this.numberValue(value, label);
        if (!Number.isInteger(number) || number < 2 || number > 201) throw new Error(label + '는 2~201 사이 정수로 입력해 주세요.');
        return number;
    }

    public predictionPayload() {
        const inputs = this.inputParameters();
        const parameters = inputs.filter(p => this.kind() !== 'curve' || !this.mainParameter || p.name !== this.mainParameter).map(p => {
            const value = this.numberValue(p.value, p.name);
            if ((p.minValue !== null && p.minValue !== undefined && value < Number(p.minValue)) || (p.maxValue !== null && p.maxValue !== undefined && value > Number(p.maxValue))) throw new Error(p.name + ' 값을 학습 범위(' + this.parameterRange(p) + ') 안에 입력해 주세요.');
            return { data_name: p.name, data_unit: p.unit || '', data: [value] };
        });
        if (!inputs.length && !['etch', 'doping'].includes(this.kind())) throw new Error('모델의 입력 파라미터가 아직 없습니다. 학습 상태를 확인하고 모델을 다시 선택해 주세요.');
        if (this.kind() === 'photo') return { sub_parameter: parameters };
        if (this.kind() === 'doping') return { process_variables: parameters, depth_num: this.count(this.depthNum, '깊이 격자 수'), lateral_num: this.count(this.lateralNum, '측면 격자 수') };
        if (this.kind() === 'etch') {
            const range = (min: any, max: any, label: string) => {
                if ((min === null || min === '') && (max === null || max === '')) return [];
                const low = this.numberValue(min, label + ' 최솟값'), high = this.numberValue(max, label + ' 최댓값');
                if (low >= high) throw new Error(label + ' 최솟값은 최댓값보다 작아야 합니다.');
                return [low, high];
            };
            return { process_parameters: parameters, y_range: range(this.yMin, this.yMax, 'Y'), z_range: range(this.zMin, this.zMax, 'Z'), grid_resolution: this.count(this.gridResolution, '격자 수'), device: 'cpu' };
        }
        if (this.kind() === 'iv') {
            const values: any = {};
            parameters.forEach(p => values[p.data_name] = p.data[0]);
            return values;
        }
        return this.mainParameter
            ? { main_parameter: this.mainParameter, sub_parameter: parameters, sample_num: this.count(this.sampleNum, '샘플 수'), param_offset: 0, sigma: { default: 2 } }
            : { main_parameter: null, sub_parameter: [], linking_parameter: { data: [parameters], coordinates: [null] }, sample_num: this.count(this.sampleNum, '샘플 수'), param_offset: 0, sigma: { default: 2 } };
    }

    public async predict() {
        if (this.busy || !this.detail || !this.usable(this.detail)) return;
        this.error = ''; this.notice = ''; this.result = null; this.resultText = '';
        let payload: any;
        try { payload = this.predictionPayload(); } catch (error: any) { this.error = error.message; await this.refresh(); return; }
        this.busy = 'predict';
        await this.refresh();
        try {
            this.result = await this.call('predict', { model_id: this.selectedId, payload: JSON.stringify(payload) });
            this.resultText = JSON.stringify(this.result, null, 2);
            this.notice = '예측이 완료되었습니다. 아래 응답에서 모델의 출력값과 단위를 확인하세요.';
        } catch (error: any) { this.error = error.message; }
        finally { this.busy = ''; await this.refresh(); }
    }

}

export default ComponentAlsphereComponent;